import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import CreateRma from "../views/CreateRma.vue";
import Dashboard from "../views/Dashboard.vue";
import Login from "../views/Login.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: "/rma/create",
    name: "CreateRma",
    component: CreateRma
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  }
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //   import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: "/portal/",
  routes
});

export default router;
